import React from 'react';
import classnames from 'classnames';
import { Tag } from 'antd';

/**
 * The table on an order card, right after the order number: a pill like the card's time chip, a
 * size up (18 px bold, 34 px high) so it reads "#5 Table 7". Long names wrap inside the pill.
 */
export default function TablePill({ label, className }) {
  if (!label) {
    return null;
  }

  return (
    <Tag
      data-testid="table-pill"
      className={classnames(
        'rounded-2xl px-sm py-2xs mr-none min-h-[34px] max-w-full inline-flex items-center',
        'text-md leading-tight font-bold whitespace-normal break-words [overflow-wrap:anywhere]',
        className,
      )}
    >
      {label}
    </Tag>
  );
}
